import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'usimweb-slider',
    template: `
    <mat-slider
      [min]="min"
      [max]="max"
      [step]="step"
      [discrete]="discrete"
      style="width: 100%"
      [displayWith]="displayWith"
      (input)="inputEvent($event)"
      (change)="changeValue($event)"
      [disabled]="disabled"
    >
      <input matSliderThumb [(ngModel)]="displayedValue" />
    </mat-slider>
  `,
    standalone: false
})
export class SliderComponent {
  @Input() displayedValue!: string | number;

  @Input() disabled: boolean = false;

  @Input() displayWith!: (value: number | string) => any;

  @Input() discrete: boolean = false;

  @Input() thumbLabel: boolean = false;

  @Input() min!: number;

  @Input() max!: number;

  @Input() step!: number;

  @Output() onChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Output() onInput = new EventEmitter<any>();

  inputEvent(event: any) {
    this.onInput.emit(event);
  }

  changeValue(event: any) {
    this.onChange.emit(event);
  }
}
